module.exports = __webpack_public_path__ + "img/mon-confort.cbf0aeeb.jpg";